<template>
  <div class="container bgWhite">
    <div>
      <embed
        :src="actualURL"
        type="application/pdf"
        width="100%"
        height="750"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
Vue.use(require("moment"));

export default {
  name: "syarat-umum",
  components: {
  },
  data: function() {
    return {
      actualURL: null,
      sCFN: 'SyaratUmum: ',
    };
  },
  async mounted() {
    let fN = 'mounted: ';
    let isAuth = await this.UserAuth();
    if (isAuth) {
      this.actualURL = this.$generalRequirementDocumentURL + "/Syarat%20Umum%20Semua%20Program.pdf"
    }
  },
  computed: {
  },
  methods: {
  },
};
</script>